// Theme Presets

const lightTheme = {
  name: "light",
  body: "#FFFFFF",
  text: "#343434",
  dark: "#000000",
  secondaryText: "#7F8DAA",
  accentColor: "#5dc0eb",
  accentBright: "#107afc",
  projectCard: "#DCE4F2",
  skinColor: "#F7B799",
  skinColor2: "#FCB696",
  imageDark: "#dce4f2",
  imageClothes: "#dce4f2",
  avatarMisc: "#e9ecf2",
  avatarShoes: "#ccd2e3",
  headerColor: "#000000",
  // Scrollbar colors
  bgColor: "#f5f5f5",
  scrollColor: "#107afc",
  scrollHoverColor: "#0d64cc",
};

const darkTheme = {
  name: "dark",
  body: "#1D1D1D",
  text: "#FFFFFF",
  dark: "#000000",
  secondaryText: "#8D8D8D",
  accentColor: "#5dc0eb",
  accentBright: "#107afc",
  projectCard: "#292A2D",
  skinColor: "#F7B799",
  skinColor2: "#FCB696",
  imageDark: "#292A2D",
  imageClothes: "#000000",
  avatarMisc: "#212121",
  avatarShoes: "#2B2B2B",
  headerColor: "#FFFFFF",
  // Scrollbar colors
  bgColor: "#292a2d",
  scrollColor: "#107afc",
  scrollHoverColor: "#2a8cff",
};

export const themes = { light: lightTheme, dark: darkTheme };
